import React from "react";
import cn from "classnames";

export const Select = ({ name, register = (e) => console.log(e), ...props }) => {
  return (
    <select
      className={cn(
        "w-full custom-select rounded-[10px] p-3 outline outline-1 outline-gray-modern-300 text-text-md placeholder:text-text-light bg-white disabled:bg-gray-modern-50 text-text-black transition focus:outline-primary-500",
        props.className
      )}
      {...register(name)}
      {...props}
    ></select>
  );
};
